import { render, staticRenderFns } from "./personReservation.vue?vue&type=template&id=59a0ba85&scoped=true"
import script from "./personReservation.vue?vue&type=script&lang=js"
export * from "./personReservation.vue?vue&type=script&lang=js"
import style0 from "./personReservation.vue?vue&type=style&index=0&id=59a0ba85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a0ba85",
  null
  
)

export default component.exports